import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getData } from '../Services/api'

const ViewFAQs = () => {
    const { id } = useParams();
    const [values, setValues] = useState({
        question: "",
        answer: "",
    })
    const fetchFAQs = async () => {
        try {
            const res = await getData(`/faqs/details/${id}`);
            if (res.status) {
                setValues(res.data || {})
            }
        } catch (error) {
            console.log("error fetch faqs", error)
        }
    }

    useEffect(() => {
        fetchFAQs();
    }, [id])

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/faqs/faq-list">FAQs</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            FAQs Details
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">FAQs Details</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>FAQs Details</h5>
                                </div>
                                <div className="card-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Question</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Title"
                                                        name='title'
                                                        value={values.question}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Answer</label>
                                                    <div className='border p-3 rounded' dangerouslySetInnerHTML={{ __html: values.answer }} />
                                                </div>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewFAQs